export default "__VITE_ASSET__102c39b4__"